import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with the publishable key from environment
export const getStripe = () => {
  const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  
  // Debug log - show only first 10 characters for security
  console.log('Stripe publishable key prefix:', publishableKey?.slice(0, 10) || 'NOT SET');
  
  if (!publishableKey) {
    console.error('VITE_STRIPE_PUBLISHABLE_KEY is not configured');
    return null;
  }
  
  if (publishableKey.includes('YOUR_KEY_HERE') || publishableKey.includes('*********')) {
    console.error('Invalid Stripe key: placeholder detected. Please set VITE_STRIPE_PUBLISHABLE_KEY in Lovable Cloud secrets.');
    return null;
  }

  return loadStripe(publishableKey);
};
